// Inject buttons again if the url changes (e.g filters)
const initMutationObserver = () => {
    let lastUrl = location.href

    new MutationObserver(() => {
        if (location.href !== lastUrl)
          {
            setTimeout(() => {
                const productCard = document.querySelector('.product-card-wrapper')
                if (productCard) {
                    if (!productCard.querySelector('.btn-add-remove-from-wishlist')) {
                        insertWishlistButtons()
                    }
                }
                initWishlist()
            }, 1000)

            lastUrl = location.href
        }
    }).observe(document, { subtree: true, childList: true })
}
initMutationObserver()
